import { t } from 'ttag'

import skillsDecoderSvg from '@h2/assets/svg/blockGraphics/skillsDecoder.svg'
import { Promotion } from '@h2/features/dashboard/promotion'

const ContinueSkillsDecoderCard = () => {
  return (
    <Promotion color="green" variant="continue">
      <Promotion.PreHeading>{t`Continue Your Goal`}</Promotion.PreHeading>
      <Promotion.Heading>{t`Take the Skills Decoder`}</Promotion.Heading>
      <Promotion.Text>{t`The skills decoder instrument will allow the system to show you a collection of skills you possess based on the experiences you have had.`}</Promotion.Text>
      <Promotion.Button href="/skills/decoder">{t`Start now`}</Promotion.Button>
      <Promotion.Image src={skillsDecoderSvg} />
    </Promotion>
  )
}

export { ContinueSkillsDecoderCard }
